import React from 'react'

import { connect } from 'react-redux'
import { withRouter, RouteComponentProps } from 'react-router-dom'
import { Container, Card } from 'react-bootstrap'

import { userCan } from 'src/store/user/userActions'
import { route } from 'src/utils/routes'
import { IState } from 'src/store'

import Error401 from 'src/pages/Error/401.page'
import Header from 'src/components/Layout/Header/Header'
import CategoryForm from 'src/components/Category/CategoryForm'

interface IProps extends RouteComponentProps {
  history: any
  user: any
  userCan: (permission: string) => boolean
}

const CategoryCreate: React.FC<IProps> = ({ history, user, userCan }) => {
  if (!userCan('create_category')) return <Error401 />

  return (
    <>
      <Header
        title="New Category"
        backText="Categories"
        onBack={() => history.push(route('categories'))}
      />
      <div className="page-container">
        <Container>
          <Card>
            <Card.Header>
              <Card.Title>Category Details</Card.Title>
            </Card.Header>
            <Card.Body className="pt-0">
              <CategoryForm user={user} />
            </Card.Body>
          </Card>
        </Container>
      </div>
    </>
  )
}

export default connect((state: IState) => ({ user: state.user }), { userCan })(
  withRouter(CategoryCreate)
)
